import { ImportColumnsDataNode } from '@bringg-frontend/csv-import-mapping-table';

export type Column = {
	translationTitleKey: string;
	dataIndex: string;
};

export const MANDATORY_FIELDS_KEY = 'EXCLUSION_WINDOWS_CSV.MANDATORY_FIELDS';
export const OPTIONAL_FIELDS_KEY = 'EXCLUSION_WINDOWS_CSV.OPTIONAL_FIELDS';
const DELETE_FIELD = 'delete';
export const TASKS_LIMIT_COLUMN: Column = {
	translationTitleKey: 'EXCLUSION_WINDOWS_CSV.TASKS_LIMIT',
	dataIndex: 'tasks_limit'
};

export const exclusionWindowsColumnsByCategory: Record<string, Column[]> = {
	[MANDATORY_FIELDS_KEY]: [
		{
			translationTitleKey: 'EXCLUSION_WINDOWS_CSV.NAME',
			dataIndex: 'name'
		},
		{
			translationTitleKey: 'EXCLUSION_WINDOWS_CSV.START_TIME',
			dataIndex: 'start_time'
		},
		{
			translationTitleKey: 'EXCLUSION_WINDOWS_CSV.END_TIME',
			dataIndex: 'end_time'
		},
		{
			translationTitleKey: 'EXCLUSION_WINDOWS_CSV.TEAM_EXTERNAL_ID',
			dataIndex: 'external_team_id'
		}
	],
	[OPTIONAL_FIELDS_KEY]: [
		{
			translationTitleKey: 'EXCLUSION_WINDOWS_CSV.ID',
			dataIndex: 'id'
		},
		{
			translationTitleKey: 'EXCLUSION_WINDOWS_CSV.SERVICE_AREA_EXTERNAL_IDS',
			dataIndex: 'service_area_external_ids'
		},
		{
			translationTitleKey: 'EXCLUSION_WINDOWS_CSV.SERVICE_PLANS_EXTERNAL_ID',
			dataIndex: 'service_plan_external_id'
		},
		{
			translationTitleKey: 'EXCLUSION_WINDOWS_CSV.EXCLUSION_TYPE',
			dataIndex: 'exclusion_type'
		},
		{
			translationTitleKey: 'EXCLUSION_WINDOWS_CSV.REPEAT',
			dataIndex: 'repeat'
		},
		{
			translationTitleKey: 'EXCLUSION_WINDOWS_CSV.DELETE',
			dataIndex: DELETE_FIELD
		}
	]
};

export const exclusionWindowsColumns = Object.values(exclusionWindowsColumnsByCategory).flat();
export const exclusionWindowsColumnsByDataIndex: Record<string, Column> = exclusionWindowsColumns.reduce(
	(acc, column) => ({
		...acc,
		[column.dataIndex]: column
	}),
	{}
);

export const exclusionWindowsColumnsTreeData: ImportColumnsDataNode[] = Object.entries(
	exclusionWindowsColumnsByCategory
).map(([category, columns]) => ({
	translationTitleKey: category,
	key: category,
	children: columns.map(({ translationTitleKey, dataIndex }) => ({
		translationTitleKey,
		key: dataIndex
	}))
}));

export function getMissingMandatoryFields(selected: string[]) {
	const selectedSet = new Set(selected);

	if (selectedSet.has(DELETE_FIELD)) {
		// If 'delete' field is selected, we don't need to check for mandatory fields
		return [];
	}

	return exclusionWindowsColumnsByCategory[MANDATORY_FIELDS_KEY].filter(field => {
		const key = field.dataIndex;
		return !selectedSet.has(key);
	});
}
